import React, { useEffect, useState } from 'react';
// Assuming fetchAPI and getStrapiMedia are helper utilities in your project
import { fetchAPI, getStrapiMedia } from '../../utils/api';


const BlogThree = () => {
    const [blogs, setBlogs] = useState([]);

    useEffect(() => {
        const getArticles = async () => {
            try {
                const response = await fetchAPI('/articles', {
                    // 1. Removed 'authors' as it isn't in the Article field list
                    // 2. Using a simpler populate string or object
                    populate: {
                        coverImage: true,
                        categories: true,
                    },
                    // 3. Simple string for sorting
                    sort: 'publishedDate:desc'
                });

                if (response.data) {
                    const mappedBlogs = response.data.map(item => ({
                        id: item.id,
                        documentId: item.documentId,
                        title: item.title,
                        image: item.coverImage ? getStrapiMedia(item.coverImage) : '/img/placeholder.jpg',
                        link: `/articles/${item.slug}`,
                        date: item.publishedDate ? new Date(item.publishedDate).toLocaleDateString() : 'Recent',
                        // Defaulting author since 'authors' field failed
                        author: "Bridges of Justice",
                        categories: item.categories ? item.categories.map(cat => cat.name) : []
                    }));
                    setBlogs(mappedBlogs);
                }
            } catch (error) {
                console.error("Error fetching articles:", error);
            }
        };
        getArticles();
    }, []);

    return (
        <div className="row items">
            {blogs.map(blog => (
                <div key={blog.documentId || blog.id} className="col-12 col-md-6 col-lg-4 item">
                    <div className="card blog-item">
                        <div className="image-holder">
                            <a className="card-thumb" href={blog.link}>
                                <img src={blog.image} alt={blog.title} />
                            </a>
                            <div className="card-overlay top fade-down">
                                <div className="logo">
                                    <img src="/img/logo.png" alt="Logo" />
                                </div>
                                <div className="post-meta d-flex flex-column ms-3">
                                    <span>Posted by</span>
                                    <span className="post-author"><strong>{blog.author}</strong></span>
                                </div>
                            </div>
                        </div>

                        <div className="card-content mt-3">
                            <div className="heading">
                                <div className="post-meta d-flex">
                                    <span className="post-date">
                                        <i className="bi bi-clock me-1"></i>{blog.date}
                                    </span>
                                </div>
                                <h4 className="title my-2">
                                    <a href={blog.link}>{blog.title}</a>
                                </h4>
                                <div className="card-terms">
                                    {blog.categories.map((category, index) => (
                                        <a key={index} className="terms badge" href={`/category/${category.toLowerCase()}`}>{category}</a>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default BlogThree;